export const s3Endpoints = {
  getDownloadUrl: "/s3/download-url",
  getUploadUrl: "/s3/upload-url",
};
